import { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { deepClone } from "../utils/objectUtilities";
import { getSelector } from "../utils/generalUtils";
import { FloatingLabel } from "./FloatingLabel";
import { ReactNodeDialog } from "../utils/dialogUtlities";
import ReactForm from "./ReactForm";
import FormEditor from "./GridEditor";
import DefaultButton from "./DefaultButton";

/**
 * Shows a compact preview of a form definition as a table
 * @component
 */
export const FormDefPreview = ({ placeholder, value, disabled = false, hideLabel = false, onChange }) => {
    const { t } = useTranslation();
    const [editing, setEditing] = useState();
    const formRef = useRef();

    const PreviewTable = useMemo(() => ({ def }) => {
        const sections = Array.isArray(def) ? def : [];
        return <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'separate', borderSpacing: 0 }} className="table text-secondary">
            <tbody>
                {sections.map((section, sIdx) => (
                    <>
                        { section?.title && !section?.borderless ? <tr key={section.uuid ?? sIdx}>
                            <td colSpan={12} className="border p-2 bg-light font-weight-bold">
                                {section?.title}
                            </td>
                        </tr> : <tr key={section.uuid ?? sIdx}><td className="p-0 border-0" colSpan={12}></td></tr>}
                        {section?.rows?.map((row, rIdx) => (
                            <tr key={sIdx + "_" + rIdx}>
                                {row?.map(cell => {
                                    return <td key={getSelector(cell)} colSpan={cell?.colspan} className="border p-2">
                                        {cell?.label && <div>{cell.label}</div>}
                                        {cell?.type && <div className="small text-muted">{cell.type}</div>}
                                    </td>
                                })}
                            </tr>
                        ))}
                    </>
                ))}
            </tbody>
        </table>
    }, []);

    return <>
        <FloatingLabel placeholder={placeholder} value={placeholder} hideLabel={hideLabel}>
            <button style={{ border: 'none' }} className="bg-transparent text-start bg-none" disabled={disabled} onClick={() => { setEditing(value ? deepClone(value) : []); }}>
                { value?.length ? <PreviewTable def={value}></PreviewTable> : <DefaultButton kind="edit" onClick={() => {}} label={t('editRows')}></DefaultButton>}
        </button>
        </FloatingLabel>
        <ReactNodeDialog showModal={editing} size="xlg" onClose={() => setEditing()} onSave={() => {
            if (formRef.current?.checkValidity()) {
                onChange?.(editing);
                setEditing();
            }
        }}>
            <ReactForm ref={formRef}>
                { editing && <FormEditor def={editing} onChange={setEditing}></FormEditor> }
            </ReactForm>
        </ReactNodeDialog>
    </>
}